<nav class="navbar fixed-top navbar-expand-lg navbar-light px-3 py-0" style="background: white;">
  <a class="navbar-brand">
    <img src="assets/logo.png" width="150" height="56">
  </a>

  <ul class="navbar-nav ml-auto">
    <p style="width: 150px;" class="">
      <ngb-progressbar [showValue]="true" type="success" [value]="countProgress"
        style="height: 1.5rem; font-size: 0.9rem; margin-bottom: -20px;"></ngb-progressbar>
    </p>
  </ul>
</nav>

<div *ngIf="measure" class="container py-3 mt-5">
  <div class="row d-flex justify-content-center">
    <div class="col-lg-10 col-md-10 col-sm-12 col-12">

      <h3 class="text-center my-5" style="color: #2D2A4A;">
        <span
          [ngClass]="measure.FONT === 'arial' ? 'Arial' : measure.FONT === 'times-new-roman' ? 'TimeNewRoman' : measure.FONT === 'calibri' ? 'Calibri' : measure.FONT === 'comic-sans-ms' ? 'ComicSansMS' : measure.FONT === 'th-sarabun' ? 'THSarabun-Header' : measure.FONT === 'K2D' ? 'K2D' : ''">
          {{ measure.MEASURE_NAME }}
        </span>
      </h3>

      <hr width="100%">

      <div class="row d-flex justify-content-center">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">

          <div *ngFor="let item of measure.details" [change]="mStatus()">
            <div [formGroup]="measureForm">
              <div *ngIf="item.TYPE === 'multi_choice'">

                <lifedi-multiple-choice [multipleChoice]="item" [measureForm]="measureForm" [type]="type"
                  [font]="measure.FONT" (progressVal)="progress($event)">
                </lifedi-multiple-choice>

              </div>

              <div *ngIf="item.TYPE === 'rating'">
                <lifedi-rating-choice [ratingChoice]="item" [measureForm]="measureForm" [type]="type"
                  [font]="measure.FONT" (progressVal)="progress($event)">
                </lifedi-rating-choice>
              </div>

              <div *ngIf="item.TYPE === 'ranking'">
                <lifedi-ranking-choice [ranking]="item" [measureForm]="measureForm" [type]="type" [font]="measure.FONT"
                  (progressVal)="progress($event)">
                </lifedi-ranking-choice>
              </div>

              <div *ngIf="item.TYPE === 'most/least'">
                <lifedi-most-least-choice [mostLeastData]="item" [measureForm]="measureForm" [type]="type"
                  [font]="measure.FONT" (progressVal)="progress($event)">
                </lifedi-most-least-choice>
              </div>

            </div>
          </div>

          <div *ngIf="isMultiInformant === 1 || (participant === 1 && participant_from)">
            <div class="d-flex justify-content-center my-3" *ngIf="measureButtonStatus">
              <button class="btn btn-success" style="width: 100px; height: 40px;" (click)="sendByInformant(measureForm)"
                *ngIf="measureForm.valid">ส่ง</button>

              <button class="btn btn-seccondary" style="background: #838383; width: 100px; height: 40px;" disabled
                *ngIf="!measureForm.valid">ส่ง</button>
            </div>
          </div>
          <div *ngIf="!isMultiInformant && (!participant && !participant_from)">
            <div class="d-flex justify-content-center my-3" *ngIf="measureButtonStatus">
              <button class="btn btn-success" style="width: 100px; height: 40px;" (click)="send(measureForm)"
                *ngIf="measureForm.valid">ส่ง</button>

              <button class="btn btn-seccondary" style="background: #838383; width: 100px; height: 40px;" disabled
                *ngIf="!measureForm.valid">ส่ง</button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>